import React, { useEffect } from "react";
import { useForm } from 'react-hook-form';
import * as yup from 'yup';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom'

import PageHelmet from "../../../component/common/Helmet";
import {  loginUser } from '../../../redux/actions';
import { isUserAuthenticated } from '../../../helpers/authUtils';

const schema = {
    email: yup.string().required('Email is required.').email('Invalid email address.'),
    password: yup.string().required('Password is required.'),
};

const LogIn = ({loginUser, loading}) => {
    const logoUrl = <img src="/assets/images/logo/logo.png" height="80" alt="EEVS Alumni" />;
    const { register, handleSubmit, setValue, errors, clearError, formState } = useForm({
        validationSchema: yup.object().shape(schema),
    });

    useEffect(() => {
        register({ name: 'email' });
        register({ name: 'password' });
    }, [register]);

    const handleInputChange = (event) => {
        const { target : { name, value } } = event;
        setValue([name], value);
        clearError();
    };

    const onSubmit = data => {
        loginUser(data.email, data.password);
     }

    const renderRedirectToRoot = () => {
        const isAuthTokenValid = isUserAuthenticated();
        if (isAuthTokenValid) {
            return <Redirect to='/dashboard' />
        }
    }

    

    return(
        
        <React.Fragment>
            {
                renderRedirectToRoot()
            }
        <PageHelmet pageTitle='Log In' />

        <div className="contact-form--1 ptb--30 fullscreen" style={{backgroundColor: '#0054a6'}}>
        <div className="container">
            <div className="row">
                <div className="col-lg-4 offset-lg-4">
                    
                        <div className="form-wrapper rn-address">
                        <div className="logo mb--30 text-center">
                            <a href="/">
                                {logoUrl}
                            </a>
                        </div>
                        
                        <form  onSubmit={handleSubmit(onSubmit)}>
                
                            <div className="form-row">
                                <label htmlFor="email">Email *</label>
                                <input
                                    type="text"
                                    name="email"
                                    id="email"
                                    onChange={handleInputChange}
                                />
                                {formState.isSubmitted && errors.email && (<div className="text-danger">{errors.email.message}</div>)}
                            </div>

                            <div className="form-row">
                                <label htmlFor="password">Password *</label>
                                <input
                                    type="password"
                                    name="password"
                                    id="password"
                                    onChange={handleInputChange}
                                />
                                {formState.isSubmitted && errors.password && (<div className="text-danger">{errors.password.message}</div>)}
                            </div>
                            
                            
                            <div className="form-row">
                                <button disabled={loading}  className="rn-button-style--2 btn-solid btn-block" type="submit" value="submit">LOG IN</button>
                            </div>
                            
                        </form>
                        
                    </div>

                </div>
            </div>
            <div className="row">
                <div className="col-lg-12">
                    <div className="text-center mt--20 text-white">
                    <strong><a href="/forgot-password" className="text-white">Forgot password? </a></strong> | Not registered yet? &nbsp;&nbsp;<strong><a href="/join-now"  className="text-white">Join Now</a>  </strong>
                    </div>    
                </div>
            </div>
        </div>        
    </div>
</React.Fragment>
    );
}

const mapStateToProps = (state) => {
    const { loading, error } = state.Auth;
    return { loading, error};
};

export default connect(mapStateToProps, { loginUser })(LogIn);